// src/constants/constantsData.ts

export const PUBLIC_ROUTES = [
  '/login',
  '/register',
  '/forgot-password',
  '/verify-otp',
  '/reset-password',
  '/403',
  '/404',
  '/500',
  '/view-invoice'
] as const;

export const mockLoginResponse = {
  data: {
    access_token: 'acf',
    refresh_token: 'rft_mock_123456',
    expires_in: 3600,
    user: {
      id: 11,
      fullname: 'Nguyễn Văn Nam',
      email: 'nguyenvannam@example.com',
      phone: '0987654321',
      currentRole: 'admin',//branch admin,//user
      avatar: '',
      status: 'active',
      branchId: null,
      createdAt: '2024-01-01T00:00:00Z',
      menus: [
        // --- NHÓM HỆ THỐNG ---
        { id: "system", idCha: null, title: "Hệ thống", icon: "fa-solid fa-gear", path: "#" },
        { id: "sys_account", idCha: "system", title: "Người dùng", path: "/system/account", roles: ["admin"] },
        { id: "sys_role", idCha: "system", title: "Vai trò", path: "/system/role", roles: ["admin"] },
        { id: "sys_login_history", idCha: "system", title: "Lịch sử đăng nhập", path: "/system/login-history", roles: ["admin"] },
        { id: "sys_api_log", idCha: "system", title: "Nhật ký API", path: "/system/api-log", roles: ["admin"] },
        { id: "sys_business_log", idCha: "system", title: "Nhật ký nghiệp vụ", path: "/system/business-log", roles: ["admin", "branch admin"] },
        // { id: "sys_setting", idCha: "system", title: "Cài đặt", path: "#" },
        { id: "sys_menu", idCha: "system", title: "Quản lý menu", path: "/system/menu", roles: ["admin"] },
        { id: "sys_app_config", idCha: "system", title: "Cấu hình App", path: "/system/app-config", roles: ["admin"] },
        // --- MENU branch admin ---
        { id: "sys_business_role", idCha: "system", title: "Nhóm chức năng nghiệp vụ", path: "/system/business-role", roles: ["branch admin"]  },
        { id: "sys_feature_access", idCha: "system", title: "Quản lý quyền truy cập tính năng", path: "/system/feature-access", roles: ["branch admin"]  },


        // --- NHÓM DANH MỤC ---
        { id: "cate", idCha: null, title: "Danh mục", icon: "fa-solid fa-server", path: "#" },
        { id: "cate_bank", idCha: "cate", title: "Ngân hàng", path: "/cate/bank", roles: ["admin"] },
        { id: "cate_region", idCha: "cate", title: "Vùng miền", path: "/cate/region", roles: ["admin"] },
        { id: "cate_weight_unit", idCha: "cate", title: "Đơn vị trọng lượng", path: "/cate/weight-unit", roles: ["admin"] },
        { id: "cate_unit", idCha: "cate", title: "Đơn vị tính", path: "/cate/unit", roles: ["admin"] },
        { id: "cate_payment", idCha: "cate", title: "Hình thức thanh toán", path: "/cate/payment-method", roles: ["admin"] },
        { id: "cate_p_group", idCha: "cate", title: "Nhóm sản phẩm", path: "/cate/product-group", roles: ["admin"] },
        { id: "cate_p_type", idCha: "cate", title: "Loại sản phẩm", path: "/cate/product-type", roles: ["admin"] },
        { id: "cate_product", idCha: "cate", title: "Sản phẩm", path: "/cate/product", roles: ["admin"]  },
        { id: "cate_attribute", idCha: "cate", title: "Thuộc tính sản phẩm", path: "/cate/product-attribute", roles: ["admin"]  },

        // --- MENU ĐƠN LẺ ---
        { id: "customer", idCha: null, title: "Khách hàng", icon: "fa-solid fa-user", path: "#" },
        { id: "customer_mgr", idCha: null, title: "Quản lý khách hàng", icon: "fa-solid fa-user-group", path: "/customer/customer-list", roles: ["admin"] },
        { id: "branch_mgr", idCha: null, title: "Quản lý cơ sở", icon: "fa-solid fa-building", path: "/cate/branch-list", roles: ["admin"] },

        // --- NHÓM QUẢN LÝ CMS ---
        { id: "cms", idCha: null, title: "Quản lý cms", icon: "fa-solid fa-border-all", path: "#" },
        { id: "cms_blog_cat", idCha: "cms", title: "Nhóm bài viết", icon: "fa-regular fa-file-lines", path: "/cms/blog-category", roles: ["admin"] },
        { id: "cms_blog", idCha: "cms", title: "Bài viết", icon: "fa-solid fa-pen", path: "/cms/blog", roles: ["admin"] },
        { id: "cms_product", idCha: "cms", title: "Sản phẩm", icon: "fa-solid fa-box", path: "/cms/product", roles: ["admin"] },
        { id: "cms_p_group", idCha: "cms", title: "Nhóm sản phẩm", icon: "fa-solid fa-tags", path: "/cms/product-category", roles: ["admin"] },
        { id: "cms_jewelry", idCha: "cms", title: "Loại trang sức", icon: "fa-solid fa-ring", path: "/cms/jewelry-category", roles: ["admin"] },
        { id: "cms_menu", idCha: "cms", title: "Menu", icon: "fa-solid fa-list", path: "/cms/menu", roles: ["admin"] },
        ]
    }
  }
} as const;

export const mockMenuData = [
  // --- NHÓM HỆ THỐNG ---
  { id: "system", idCha: null, title: "Hệ thống", icon: "fa-solid fa-gear", path: "#" },
  { id: "sys_account", idCha: "system", title: "Người dùng", path: "/system/account" },
  { id: "sys_role", idCha: "system", title: "Vai trò", path: "/system/role" },
  { id: "sys_login_history", idCha: "system", title: "Lịch sử đăng nhập", path: "/system/login-history" },
  { id: "sys_api_log", idCha: "system", title: "Nhật ký API", path: "/system/api-log" },
  { id: "sys_business_log", idCha: "system", title: "Nhật ký nghiệp vụ", path: "/system/business-log" },
  { id: "sys_setting", idCha: "system", title: "Cài đặt", path: "#" },
  { id: "sys_menu", idCha: "system", title: "Quản lý menu", path: "/system/menu" },
  { id: "sys_app_config", idCha: "system", title: "Cấu hình App", path: "#" },

  // --- NHÓM DANH MỤC ---
  { id: "cate", idCha: null, title: "Danh mục", icon: "fa-solid fa-server", path: "#" },
  { id: "cate_bank", idCha: "cate", title: "Ngân hàng", path: "/cate/bank" },
  { id: "cate_region", idCha: "cate", title: "Vùng miền", path: "/cate/region" },
  { id: "cate_weight_unit", idCha: "cate", title: "Đơn vị trọng lượng", path: "/cate/weight-unit" },
  { id: "cate_unit", idCha: "cate", title: "Đơn vị tính", path: "/cate/unit" },
  { id: "cate_payment", idCha: "cate", title: "Hình thức thanh toán", path: "/cate/payment-method" },
  { id: "cate_p_group", idCha: "cate", title: "Nhóm sản phẩm", path: "/cate/product-group" },
  { id: "cate_p_type", idCha: "cate", title: "Loại sản phẩm", path: "/cate/product-type" },
  { id: "cate_product", idCha: "cate", title: "Sản phẩm", path: "/cate/product" },
  { id: "cate_attribute", idCha: "cate", title: "Thuộc tính sản phẩm", path: "/cate/product-attribute" },

  // --- MENU ĐƠN LẺ ---
  { id: "customer_mgr", idCha: null, title: "Quản lý khách hàng", icon: "fa-solid fa-user-group", path: "/customer/customer-list" },
  { id: "branch_mgr", idCha: null, title: "Quản lý cơ sở", icon: "fa-solid fa-building", path: "/cate/branch-list" },

  // --- NHÓM QUẢN LÝ CMS ---
  { id: "cms", idCha: null, title: "Quản lý cms", icon: "fa-solid fa-border-all", path: "#" },
  { id: "cms_blog_cat", idCha: "cms", title: "Nhóm bài viết", icon: "fa-regular fa-file-lines", path: "/cms/blog-category" },
  { id: "cms_blog", idCha: "cms", title: "Bài viết", icon: "fa-solid fa-pen", path: "/cms/blog" },
  { id: "cms_product", idCha: "cms", title: "Sản phẩm", icon: "fa-solid fa-box", path: "/cms/product" },
  { id: "cms_p_group", idCha: "cms", title: "Nhóm sản phẩm", icon: "fa-solid fa-tags", path: "/cms/product-category" },
  { id: "cms_jewelry", idCha: "cms", title: "Loại trang sức", icon: "fa-solid fa-ring", path: "/cms/jewelry-category" },
  { id: "cms_menu", idCha: "cms", title: "Menu", icon: "fa-solid fa-list", path: "/cms/menu" },
] as const;